import trina415 from "../../images/trina415.webp";
import USFlag from "../../images/USFlag.png";
import SingFlag from "../../images/SingaporeFlag.png";
import italianFlag from "../../images/italian-flag.webp";
import chinaFlag from "../../images/chinaflag.webp";
import Powerwall3 from "../../images/Powerwall3.png";
import Enphase10C from "../../images/Enphase10C.webp";
import IQ8PLUS from "../../images/IQ8PLUS.png";
import TeslaInverter from "../../images/TeslaInverter2.jpg";
import TeslaWallConnector from "../../images/Tesla-Universal-Wall-Connector.webp";
import ja405 from "../../images/JASolar405.webp";
import rec460 from "../../images/REC460.webp";
import maxeon410 from "../../images/maxeon410.jpg";
import SolarEdge from "../../images/solaredge_inverter.png";
import peimar450 from "../../images/peimar-450-solar-panel.webp";
import sunket from "../../images/sunket455.webp";
import qcell from "../../images/qcell.webp";
import powerq from "../../images/PowerQ.png";

export const solarData = {
  modules: {
    title: "Modules",
    options: [
      // {
      //   name: "Mission Solar",
      //   image: missionSolar,
      //   watts: 410,
      //   ppw: 2.05,
      //   ppwNE: 3,
      //   column1: {
      //     "Rated Power": "410W",
      //     // "Efficiency": "21%"
      //   },
      //   column2: {
      //     "Warranty": "25 years"
      //   },
      //   "Spec Sheet": "/files/MissionSolar.pdf",
      //   manufacturerLocationImage: USFlag,
      // },
      // {
      //   name: "Trina Solar",
      //   image: trina415,
      //   watts: 415,
      //   ppw: 2.05,
      //   ppwNE: 3,
      //   auroraModuleName: "TSM-NE09RC.05 415",
      //   column1: {
      //     "Rated Power": "415W",
      //     // "Efficiency": "21%"
      //   },
      //   column2: {
      //     "Warranty": "25 years"
      //   },
      //   "Spec Sheet": "/files/Trina415Specs.pdf",
      //   manufacturerLocationImage: USFlag,
      // },
      // {
      //   name: "JA Solar 405",
      //   image: ja405,
      //   watts: 405,
      //   ppw: 2.3,
      //   ppwNE: 3,
      //   auroraModuleName: "JAM54S31 405/MR (1500V)",
      //   column1: {
      //     "Rated Power": "405W",
      //     // "Efficiency": "21%"
      //   },
      //   column2: {
      //     "Warranty": "25 years"
      //   },
      //   "Spec Sheet": "/files/JASolar405.pdf",
      //   manufacturerLocation: "USA",
      //   manufacturerLocationImage: USFlag,
      // },
      {
        name: "Sunket 455W",
        image: sunket,
        watts: 455,
        ppw: 1.85,
        ppwNE: 2.45,
        auroraModuleName: "SKT455M10-120D5",
        column1: {
          "Rated Power": "455W",
          // "Efficiency": "22.6%"
        },
        column2: {
          Warranty: "25 years",
        },
        "Spec Sheet": "/files/SunketSpecs.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      },
      {
        name: "QCell 410W",
        image: qcell,
        watts: 410,
        ppw: 2.2,
        ppwNE: 2.45,
        auroraModuleName: "Q.PEAK DUO BLK ML-G10.C+ 410",
        column1: {
          "Rated Power": "410W",
          // "Efficiency": "22.6%"
        },
        column2: {
          Warranty: "25 years",
        },
        "Spec Sheet": "/files/qcell410specs.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      },
      // {
      //   name: "REC460AA Pure-RX",
      //   image: rec460,
      //   watts: 460,
      //   ppw: 2.25,
      //   ppwNE: 2.65,
      //   auroraModuleName: "REC460AA PURE-RX",
      //   column1: {
      //     "Rated Power": "460W",
      //     // "Efficiency": "22.6%"
      //   },
      //   column2: {
      //     Warranty: "25 years",
      //   },
      //   "Spec Sheet": "/files/REC460.pdf",
      //   manufacturerLocation: "Singapore",
      //   manufacturerLocationImage: SingFlag,
      // },
    ],
  },
  inverters: {
    title: "Inverters",
    options: [
      {
        name: "FoxEss PowerQ Inverter",
        image: powerq,
        ppw: 0,
        auroraInverterName: "Tesla Solar Inverter 7.6 [240V]",
        column1: {
          Type: "String Inverter",
        },
        column2: {
          Warranty: "10 years",
        },
        "Spec Sheet": "/files/FoxSpecs.pdf",
        manufacturerLocation: "China",
        manufacturerLocationImage: chinaFlag,
      },
      {
        name: "SolarEdge 11.4kW Inverter",
        image: SolarEdge,
        ppw: 0.15,
        auroraInverterName: "USE11400H-USSKBEZ8 (11400W)",
        column1: {
          Type: "Optimized String Inverter",
        },
        column2: {
          Warranty: "12 years",
        },
        "Spec Sheet": "/files/SolarEdge_Inverter.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      },
      {
        name: "Enphase IQ8+",
        image: IQ8PLUS,
        ppw: 0.15,
        auroraInverterName: "IQ8PLUS-72-M-US",
        column1: {
          Type: "Microinverter",
        },
        column2: {
          Warranty: "25 years",
        },
        "Spec Sheet": "/files/IQ8SP.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      },
      {
        name: "Tesla Inverter",
        image: TeslaInverter,
        ppw: 0,
        auroraInverterName: "Tesla Solar Inverter 7.6 [240V]",
        column1: {
          Type: "String Inverter",
        },
        column2: {
          Warranty: "10 years",
        },
        "Spec Sheet": "/files/TeslaInverterSpecs.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      }
    ],
  },
  batteries: {
    title: "Batteries",
    options: [
      {
        name: "FoxESS PowerQ Battery",
        image: powerq,
        firstUnit: 2000,
        additionalUnits: 2000,
        capacity: 3.97,
        column1: {
          Capacity: "3.97 kWh",
        },
        column2: {
          Warranty: "10 years",
        },
        "Spec Sheet": "/files/FoxSpecs.pdf",
        manufacturerLocation: "China",
        manufacturerLocationImage: chinaFlag,
      },
      {
        name: "Tesla Powerwall 3",
        image: Powerwall3,
        firstUnit: 15500,
        additionalUnits: 9500,
        inverterPrice: 11500,
        auroraInverterName: "Powerwall 3 (integrated inverter)",
        capacity: 13.5,
        column1: {
          Capacity: "13.5 kWh",
        },
        column2: {
          Warranty: "10 years",
        },
        "Spec Sheet": "/files/Powerwall3Specs.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      }
    ],
  },
  services: {
    title: "EV Chargers",
    options: [
      {
        name: "Tesla Wall Connector",
        image: TeslaWallConnector,
        price: 1400,
        column1: {
          "Max Current": "48Amps",
        },
        column2: {
          Voltage: "200-240 (Level 2)",
        },
        "Spec Sheet": "/files/Tesla-Wall-Connector-Datasheet.pdf",
        manufacturerLocation: "USA",
        manufacturerLocationImage: USFlag,
      },
    ],
  },
};
